//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EditSchedule from './../../pages/main/sections/Calendar/EditSchedule.vue'
import { convertEmployeesScheduleFromServer } from './../../pages/main/sections/Calendar/CalendarUtils.js'
import CardPropertyIcon from './../../components/Card/CardPropertyIcon.vue'
import { formatDate } from '../../components/helpers.js'
import { axiosGet } from '../../axios/axios.js'
import { mapGetters } from 'vuex'

export default {
  name: 'EmployeePropertyWorkShift',
  components: {
    EditSchedule,
    CardPropertyIcon
  },
  props: {
    tabProp: {
      type: Object,
      default: null
    },
    object: {
      type: Object,
      default: null
    },
    objectInitial: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      loading: false,
      changed: false,
      scheduleSingle: null,
      overtimeTariffs: [],
      additionalOvertimeTariffs: [],
      openedEditSchedule: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      getWorkShifts: 'getWorkShifts'
    }),
    workShifts: function () {
      return [
        {
          name: 'Своя смена',
          key: 'brigadier.custom',
          startHour: 8,
          endHour: 17
        },
        ...this.getWorkShifts
      ]
    },
    label: function () {
      // if (this.object._objectParams && this.object._objectParams.workDate) {
      if (this.object.$D_workDate) {
        return this.tabProp._nameUpperCase + ' (на ' + formatDate(this.object.$D_workDate) + ')'
      }
      return this.tabProp._nameUpperCase
    },
    listvalues: function () {
      return this.getWorkShifts
    },
    readonly: function () {
      return !(this.tabProp.editable && this.$d_hasOperation('changeEmployeeSchedule'))
    },
    classes: function () {
      const classes = []
      if (!this.readonly) {
        classes.push('d-field-editable')
      }
      if (this.changed) {
        classes.push('object-card-property-changed')
      }
      return classes.length ? classes.join(' ') : undefined
    }
  },
  watch: {
    object: {
      handler: function (object) {
        if (object) {
          if (object.$D_workDate != null) {
            if (this.tabProp._shown === false) {
              this.tabProp._shown = true
            }
          } else {
            this.tabProp._shown = false
          }
        }
      },
      immediate: true
    },
    objectInitial: {
      handler: function (object) {
        if (object) {
          this.updateChangeFlag()
        } else {
          this.changed = false
        }
      },
      immediate: true
    }
  },
  methods: {
    onChange: function (value) {
      this.updateChangeFlag()
    },
    updateChangeFlag: function () {
      if (this.object._card && this.object._card.indicateChanges) {
        const value = this.getValue()
        const valueInitial = this.getValue(this.objectInitial)
        this.changed = value !== valueInitial
      }
    },
    getValue: function (object = this.object) {
      const value = object[this.tabProp.key]
      return value != null && typeof value === 'object' ? value.key : value
    },
    onScheduleEditorOpen: function () {
      this.loadWorkDay()
        .then(() => {
          this.openedEditSchedule = true
        })
    },
    onScheduleChanged: function () {
      // TODO
      // this.object._card.updateObject()
      this.object._card.loadObjectData()
        .then(objectData => {
          const objectSrc = objectData.object
          this.object.$D_workShift = objectSrc.$D_workShift
          this.object.$D_workDate = objectSrc.$D_workDate

          this.object._card.objectInitial = JSON.parse(JSON.stringify(objectSrc))
          this.object._card.emitSaved()
        })
    },
    onScheduleEditorClosed: function () {
      this.openedEditSchedule = false
      // this.scheduleSingle = []
    },
    loadWorkDay: function () {
      const object = this.object
      if (object && object.$D_workDate) {
        this.loading = true
        return axiosGet({
          url: '/service/delta/workday/get?date=' + object.$D_workDate + '&id=' + object.$id + '&filter=none',
          onSuccess: (response) => {
            const overtimeTariffs = response.data.overtimeTariffs
            this.overtimeTariffs = overtimeTariffs && overtimeTariffs.length ? overtimeTariffs : [{ value: null, name: 'Пустая переработка' }]
            this.additionalOvertimeTariffs = response.data.additionalOvertimeTariffs && response.data.additionalOvertimeTariffs.length ? response.data.additionalOvertimeTariffs : []

            this.scheduleSingle = convertEmployeesScheduleFromServer(response.data.employees, response.data.workDays)
            // const workDays = this.scheduleSingle[0].schedule
            // if (workDays && workDays.length) {
            //   console.log(workDays[0])
            //   console.log(object.$D_workShift)
            // }
          },
          onFailure: 'Ошибка получения данных о рабочем дне сотрудника',
          msgTarget: this,
          throws: true
        }).finally(() => {
          this.loading = false
        })
      }
      return Promise.reject(new Error('Не определен рабочий день'))
    }
  }
}
